// extracted by mini-css-extract-plugin
export var bannerContainer = "banner-variant-module--bannerContainer--72ad7";
export var bannerContent = "banner-variant-module--bannerContent--95564";
export var bannerVariantBannerContainer = "banner-variant-module--bannerVariantBannerContainer--d4b32";
export var bannerVariantSubtitle = "banner-variant-module--bannerVariantSubtitle--3dd0b";
export var bannerVariantText = "banner-variant-module--bannerVariantText--ec307";
export var center = "banner-variant-module--center--d43dc";
export var hasBorder = "banner-variant-module--hasBorder--fdc31";
export var image = "banner-variant-module--image--cd348";
export var moduleContainer = "banner-variant-module--moduleContainer--30033";